import React, { useState, useEffect, Fragment } from 'react';

import { Card, CardBody, CardTitle, Button, Badge } from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { NavLink } from 'react-router-dom';
import moment from 'moment';
import { gAPI_Conversations_list } from '../../../../../constants/APIs';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import ReactHtmlParser from 'react-html-parser';
import ChatListItem from '../../../../../components/chats/ChatListItem';
import 'react-datepicker/dist/react-datepicker.css';
import Masking from '../../../../../data/Masking';
import messenger_icon from '../../../../../assets/messenger_icon.png';
import website_icon from '../../../../../assets/website_icon.png';
import google_icon from '../../../../../assets/google_icon.png';
import { faLock, faLockOpen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import noallConversation from '../../../../../assets/no_allconvo.png'
const Archives = ({
  startDate,
  endDate,
  offset,
  items,
  isLoading,
  data,
  activeIndex,
  handleContactClick,
  pid,
  loadMoreConversations,
  handleMaskClick,
  isMasked,
  properties,
}) => {
  const [conversations, setConversations] = useState(data);
  //   const [offsetNum, setOffsetNum] = useState(offset || null);
  const [itemsNum, setItemsNum] = useState(items || null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setConversations(data);
  }, [data]);

  const getImage = (phoneNumber, source) => {
    if (source === 'Phone') {
      if (phoneNumber !== '' && phoneNumber !== undefined) {
        if (
          phoneNumber.startsWith('+6422') ||
          phoneNumber.startsWith('+6427') ||
          phoneNumber.startsWith('+6421') ||
          phoneNumber.startsWith('+6428') ||
          phoneNumber.startsWith('+6429')
        ) {
          return (
            <img
              src="https://assets.bookmebob.com/images/mobile.png"
              alt="mobile"
              className="img-thumbnail border-0 mt-2 ml-2"
              style={{ maxWidth: '35px' }}
            />
          );
        } else {
          return (
            <img
              src="https://assets.bookmebob.com/images/landline.png"
              alt="landline"
              className="img-thumbnail border-0 mt-2 ml-2"
              style={{ maxWidth: '35px' }}
            />
          );
        }
      } else {
        return (
          <img
            src="https://assets.bookmebob.com/images/chat.png"
            alt="chat"
            className="img-thumbnail border-0 mt-2 ml-2"
            style={{ maxWidth: '35px' }}
          />
        );
      }
    } else if (source === 'PhoneSuite') {
      return <i className="simple-icon-call-in" style={{ fontSize: '25px' }} />;
    } else if (source === 'WebsiteDirectLine') {
      return <i className="simple-icon-globe" style={{ fontSize: '25px' }} />;
    } else if (source === 'EmailDirectLine') {
      return <i className="iconsminds-envelope" style={{ fontSize: '25px' }} />;
    } else if (source === 'GoogleBusinessMessage') {
      return (
        <img
          src={google_icon}
          alt="google"
          className="img-thumbnail border-0 mt-2"
          style={{ maxWidth: '25px' }}
        />
      );
    } else if (source === 'WhatsApp') {
      return (
        <img
          src="https://assets.bookmebob.com/images/whatsapp_icon.png"
          alt="whatsapp"
          className="img-thumbnail border-0 mt-2 "
          style={{ maxWidth: '28px' }}
        />
      );
    } else if (source === 'FacebookDirectLine') {
      return (
        <img
          src={messenger_icon}
          alt="facebook"
          className="img-thumbnail border-0 mt-2"
          style={{ maxWidth: '25px' }}
        />
      );
    } else {
      return (
        <img
          src="https://assets.bookmebob.com/images/chat.png"
          alt="chat"
          className="img-thumbnail border-0 mt-2"
          style={{ maxWidth: '25px' }}
        />
      );
    }
  };
  // const getImage = (phoneNumber, source) => {
  //   if (source === 'Phone') {
  //     if (phoneNumber !== '' && phoneNumber !== undefined) {
  //       if (
  //         phoneNumber.startsWith('+6422') ||
  //         phoneNumber.startsWith('+6427') ||
  //         phoneNumber.startsWith('+6421') ||
  //         phoneNumber.startsWith('+6428') ||
  //         phoneNumber.startsWith('+6429')
  //       ) {
  //         return 'https://assets.bookmebob.com/images/mobile.png';
  //       } else {
  //         return 'https://assets.bookmebob.com/images/landline.png';
  //       }
  //     } else {
  //       return 'https://assets.bookmebob.com/images/chat.png';
  //     }
  //   }
  //   else if (source === 'PhoneSuite') {
  //     return 'https://assets.bookmebob.com/images/664a7811-8899-4255-8fe8-a12a6bd8b500.png';
  //   }
  //   else if (source === 'WebsiteDirectLine') {
  //     return 'https://assets.bookmebob.com/images/2504d2db-ab38-4616-a7ea-d16a4e81bd6f.png';
  //   }
  //   else if (source === 'GoogleBusinessMessage') {
  //     return google_icon;
  //   }
  //   else if (source === 'WhatsApp') {
  //     return 'https://assets.bookmebob.com/images/whatsapp_icon.png';
  //   }
  //   else if (source === 'FacebookDirectLine') {
  //     return messenger_icon;
  //   }
  //   else {
  //     return 'https://assets.bookmebob.com/images/chat.png';
  //   }
  // };

  // useEffect(() => {
  //   const start = moment(startDate).format('YYYY-MM-DD') + ' 00:00:00';
  //   const end = moment(endDate).format('YYYY-MM-DD') + ' 23:59:59';
  //   AxiosAPI({
  //     methhod: 'get',
  //     url: `${gAPI_Conversations_list}?gid=${getGroupID()}&pid=${pid}&df=${start}&dt=${end}&tags=-1&offset=${0}&limit=${itemsNum}&country=-1&facebookSenderName=`,
  //     //  url: `${gAPI_Conversations_list}?gid=${getGroupID()}&country=${
  //     //    code.length > 0 ? code.map(a => a.value).join('|') : '-1'
  //     //  }&tags=${
  //     //    topicName.length > 0
  //     //      ? topicName.map(a => a.value).join('|')
  //     //      : '-1'
  //     //  }&pid=${
  //     //    hotel.length > 0 ? hotel.map(a => a.value).join('|') : '-1'
  //     //  }&df=${start}&dt=${end}&offset=${offset}&limit=${items}`,
  //   }).then(res => {
  //     setConversations(res.data.conversations);
  //     setLoading(false);
  //   });
  // }, [itemsNum, endDate, startDate]);

  const loadMore = () => {
    // setOffsetNum(offsetNum + 30);
    // setItemsNum(itemsNum + 30);
    // setLoading(true);
    loadMoreConversations();
  };

  const [showButton, setShowButton] = useState(false);
  const handleScroll = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop - 10 <= e.target.clientHeight;
    if (bottom && conversations.length > 0) {
      setShowButton(true);
    }
  };
  return (
    <Fragment>
      {/* <CardTitle>Archives</CardTitle> */}
      <div
        className="cardHeight archive-card"
        style={{ scrollbarColor: 'darkgrey white' }}
        onScroll={handleScroll}
      >
        <div>
          <div className="scroll">
            {!isLoading ? (
              <div>
                {conversations.length > 0 ? (
                  <div>
                    <div>
                      {conversations.map((chat, index) => {
                        return (
                          // <Fragment>
                          //   <NavLink
                          //     key={`chat_${index}`}
                          //     className={
                          //       activeIndex === index
                          //         ? 'd-flex selectedchat'
                          //         : 'd-flex'
                          //     }
                          //     to="#"
                          //     onClick={() =>
                          //       handleContactClick(index, chat.conversationId)
                          //     }
                          //   >
                          //     <ChatListItem key={`chat_${index}`} item={chat} />
                          //   </NavLink>
                          // </Fragment>
                          <div
                            key={`chat_${index}`}
                            className={
                              activeIndex === index
                                ? 'd-flex flex-row mb-3 border-bottom selectedchat'
                                : 'd-flex flex-row mb-3 border-bottom'
                            }
                            style={{ cursor: 'pointer' }}
                            onClick={() =>
                              handleContactClick(index, chat.conversationId)
                            }
                          >
                            <div
                              className="d-block"
                              style={{ alignContent: 'center' }}
                            >
                              {getImage(chat.phoneNumber, chat.channel)}
                              {/* <img
                              src={getImage(chat.phoneNumber, chat.channel)}
                              alt={'chat'}
                              className="img-thumbnail border-0 mt-2 ml-2"
                              style={{ maxWidth: '35px' }}
                            /> */}
                            </div>
                            <div className="pl-3 pt-2 pr-2 pb-2">
                              <div className="pr-4">
                                {pid === '-1' &&
                                  chat.propertyId !== undefined &&
                                  properties !== undefined &&
                                  properties.length > 0 &&
                                  properties.filter(
                                    (p) => p.id === chat.propertyId
                                  ).length > 0 && (
                                    <span className="badge badge-pill badge-primary position-absolute badge-conversation badge ">
                                      {
                                        properties.filter(
                                          (p) => p.id === chat.propertyId
                                        )[0].name
                                      }
                                    </span>
                                  )}
                                <div className="text-primary text-small font-weight-medium d-none d-sm-block">
                                  {moment(chat.startedUtc).format(
                                    'MMM DD, YYYY h:mm a'
                                  )}
                                  &nbsp; ({chat.visitorMessageCount})
                                </div>
                                {chat.channel === 'EmailDirectLine' ? (
                                  <p className="mb-1 text-small my-1"></p>
                                ) : (
                                  <p className="mb-1 text-small">{chat.detail}</p>
                                )}
                                <p className="text-muted mb-1 text-small">
                                  {isMasked !== 'true' ? (
                                    <Masking
                                      input={chat.phoneNumber}
                                      inputType={'mobile'}
                                      number={4}
                                    ></Masking>
                                  ) : (
                                    chat.phoneNumber
                                  )}
                                  {chat.phoneNumber !== '' &&
                                    chat.phoneNumber !== null && (
                                      <span
                                        className="text-muted ml-1"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => handleMaskClick()}
                                      >
                                        <FontAwesomeIcon
                                          icon={
                                            isMasked === 'true'
                                              ? faLock
                                              : faLockOpen
                                          }
                                          className="fa"
                                        />
                                      </span>
                                    )}
                                </p>
                                <p className="text-muted mb-1 text-small">
                                  {isMasked !== 'true' ? (
                                    <Masking
                                      input={chat.email}
                                      inputType={'email'}
                                    ></Masking>
                                  ) : (
                                    chat.email
                                  )}
                                  {chat.email !== '' && chat.email !== null && (
                                    <span
                                      className="ml-1"
                                      style={{ cursor: 'pointer' }}
                                      onClick={() => handleMaskClick()}
                                    >
                                      <FontAwesomeIcon
                                        icon={
                                          isMasked === 'true'
                                            ? faLock
                                            : faLockOpen
                                        }
                                        className="fa"
                                      />
                                    </span>
                                  )}
                                </p>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )
                  : (
                    <Fragment>
                      <div className='text-center no-ticket'>

                        <img
                          src={noallConversation}
                          alt="No Tickets"
                          style={{
                            width: '80%',
                          }}
                        />
                      </div>
                    </Fragment>
                  )
                }
              </div>
            ) : (
              <div className="loading" />
            )}
          </div>
          {loading && (
            <div
              style={{ textAlign: 'center', fontSize: '16px', margin: '8px 0' }}
            >
              Loading ...
            </div>
          )}
          {showButton && (
            <Button
              style={{ margin: '8px 0', float: 'right' }}
              color="primary"
              size="sm"
              onClick={loadMore}
            >
              More
            </Button>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default Archives;
